import SmoothCollapse from "react-smooth-collapse";

import { Stack } from "../../layout";

type Props = {
  showError: boolean;
  children: {
    label: React.ReactNode;
    field: React.ReactNode;
    error?: React.ReactNode;
  };
};

export default function FieldLayout(props: Props) {
  const {
    children: { label, field, error },
    showError
  } = props;
  return (
    <Stack space="small">
      {label}
      {field}
      <SmoothCollapse expanded={showError}>{error}</SmoothCollapse>
    </Stack>
  );
}
